// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInternalDevkitPortal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <g
      fill="currentColor"
      fillRule="evenodd"
      clipPath="url(#internal-devkit-portal_svg__a)"
      clipRule="evenodd"
    >
      <path d="M10.396 18.509c0 .322-.301.56-.607.458-2.286-.769-4.048-2.833-4.603-5.257-.877-3.8 1.426-7.63 5.21-8.517 3.785-.887 7.542 1.498 8.42 5.299.829 3.592-1.209 7.343-4.631 8.477-.306.102-.608-.137-.608-.46v-2.564c0-.196.116-.371.286-.468a3.904 3.904 0 0 0 1.607-1.768c.877-1.941.027-4.412-1.893-5.3-1.92-.887-4.195-.027-5.073 1.914-.833 1.844-.109 4.164 1.609 5.153a.547.547 0 0 1 .283.467z" />
      <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z" />
    </g>
    <defs>
      <clipPath id="internal-devkit-portal_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInternalDevkitPortal;
